/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp.  2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
define([
	'../lib/@waca/core-client/js/core-client/utils/PerfUtils'
], function (PerfUtils) {
	'use strict';



	class ProfileFeatureTracker {
		/**
		 * Coordinates loading of features, based on current profile, across dashboard & content feature loaders
		 */
		constructor(profiles=[]) {
			this._enable = false;
			this._profile = ['core'];
			if(profiles && profiles.includes('authoring') && !profiles.includes('consume')) {
				this._profile.push('consume');
			}
			for(let i=0;i< profiles.length; i++) {
				const profile = profiles[i];
				if(profile !== 'core') {
					this._profile.push(profile);
				}
			}
			this._onProfileChangeCb = null; //only for test automation
		}

		getAPI() {
			return {
				getCurrentProfileList: this.getCurrentProfile.bind(this),
				getLoadedFeatures: this._getLoadedFeatures.bind(this),
				onProfileChange: this._onProfileChange.bind(this)
			};
		}

		_onProfileChange(fn)  {
			this._onProfileChangeCb = fn;
		}

		setDashboardFeatureLoader( loader ) {
			this.dashboardFeatureLoader = loader;
		}

		setRootContent( content ) {
			this.rootContent = content;
		}

		enable(flag){
			this._enable = flag;
		}

		isEnabled() {
			return this._enable;
		}

		getCurrentProfile( ) {
			if(!this._enable) {
				return undefined;
			}
			return this._profile ;
		}


		updateCurrentProfile( params ) {
			if( !this.isEnabled() ) {
				return Promise.resolve(true);
			}

			PerfUtils.createPerformanceMark({
				'component': 'dashboard',
				'name': 'feature profile update',
				'state': 'start'
			});

			let dashboardPromise;
			if( this.dashboardFeatureLoader ) {
				dashboardPromise = this.dashboardFeatureLoader.updateCurrentProfile( params );
			} else {
				dashboardPromise = Promise.resolve(true);
			}
			return dashboardPromise.then( () => {
				if( this.rootContent ) {
					return this.rootContent.updateCurrentProfile( params )
						.then( (resolved)=> {
							if( this.dashboardFeatureLoader ){
								this._profile = this.dashboardFeatureLoader.getCurrentProfile();
							}
							this._onProfileChangeCb  && this._onProfileChangeCb();
							this._onProfileChangeCb= null;
							PerfUtils.createPerformanceMark({
								'component': 'dashboard',
								'name': 'feature profile update',
								'state': 'end'
							});
							return resolved;
						} );
				} else {
					this._onProfileChangeCb  && this._onProfileChangeCb();
					this._onProfileChangeCb= null;
					return Promise.resolve(true);
				}

			} );


		}

		_getLoadedFeatures() {
			let dashboardInfo = this.dashboardFeatureLoader && this.dashboardFeatureLoader.getLoadedFeatureProfileInfo();
			let contentInfo = this.rootContent && this.rootContent.getLoadedFeatureProfileInfo();

			return {
				dashboardFeatures: dashboardInfo || [],
				contentFeatures: contentInfo || []
			};
		}

	}

	return ProfileFeatureTracker;
});
